module.exports = __webpack_public_path__ + "static/text4-da70383418732daef8cd732c12b591be.svg";